import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Plugin, PluginKey } from 'prosemirror-state';
import { getIconItem } from '../../utils/menu';
import { insertTodos } from './actions';
import { todoNodes } from './todoNode';
import './Todos.scss';
import { MENU_GROUP_TYPES } from '../../utils/constants';
const pluginKey = new PluginKey('todos');
const getTodoListPosition = state => {
  const todoNode = state.schema.nodes.todos;
  const node = state.doc.nodeAt(state.selection.$from.pos);
  return node && node.type === todoNode ? state.selection.$from.pos : null;
};
export default {
  name: 'todos',
  defaultOptions: {
    enableOnReadOnlyMode: true
  },
  configure: options => ({
    nodes: _objectSpread({}, todoNodes(options)),
    plugin: new Plugin({
      key: pluginKey,
      state: {
        init: (_, state) => ({
          pos: getTodoListPosition(state)
        }),
        apply: (tr, pluginState, _oldState, newState) => {
          return pluginState;
        }
      }
    }),
    menuItems: [getIconItem('insert-todo_list', 'icon-start-checkin', 'Create Todo List', insertTodos, {
      group: MENU_GROUP_TYPES.TEXT_ALIGNMENTS
    })]
  })
};